<template>
    <div class="user my-camp-reg camp-member-page">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1>{{ title }}</h1>
                <b-button variant="outline-secondary" size="sm" @click="logout">登出</b-button>
            </b-container>
        </div>
        <b-container fluid="xl">
            <b-row>
                <b-col cols="12" md="2" class="member-sidebar-col">
                    <nacUser></nacUser>
                </b-col>
                <b-col cols="12" md="10" class="member-content-col">
                    <b-card class="mb-3">
                        <template #header>
                            <span class="font-weight-bold">報名列表</span>
                        </template>
                        <div>
                            <b-row class="mb-3" align-h="end">
                                <b-col cols="12" md="6" lg="5">
                                    <b-input-group>
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="search"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-input v-model="Search.keywords"
                                            placeholder="訂單編號 / 系列 / 營隊 / 梯次 / 學員姓名"></b-form-input>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                            <!-- 桌機表格 -->
                            <div class="d-none d-md-block">
                            <b-table hover :items="items" :fields="fields"
                                :tbody-tr-class="rowClass" show-empty empty-text="目前沒有營隊報名紀錄"
                                class="camp-reg-table camp-member-table">
                                <template #cell(RelationName)="{ item }">
                                    <span class="font-weight-bold">{{ item.RelationName }}</span>
                                </template>
                                <template #cell(CampProgramTitle)="{ item }">
                                    <div v-if="item.CampSeriesTitle" class="small text-muted">{{ item.CampSeriesTitle }}</div>
                                    <div>{{ item.CampProgramTitle }}</div>
                                </template>
                                <template #cell(CampProductTitle)="{ item }">
                                    <div>{{ item.CampProductTitle }}</div>
                                    <div v-if="item.CampProductStart" class="small text-muted">
                                        {{ item.CampProductStart | datefmt('YYYY/MM/DD') }} ~ {{ item.CampProductEnd | datefmt('YYYY/MM/DD') }}
                                    </div>
                                </template>
                                <template #cell(OrderState)="{ item }">
                                    <b-badge :variant="item.OrderState === '已取消' ? 'secondary' : 'success'">
                                        {{ item.OrderState }}
                                    </b-badge>
                                </template>
                                <template #cell(tool)="{ item }">
                                    <b-button variant="link" @click="openDetail(item.OrderDetailId)"
                                        v-b-tooltip.hover title="查看">
                                        <b-icon icon="eye-fill"></b-icon>
                                    </b-button>
                                    <b-button v-if="canPayItem(item)" variant="link" class="text-danger"
                                        @click="openCancelModal(item)" v-b-tooltip.hover title="取消報名">
                                        <b-icon icon="x-circle"></b-icon>
                                    </b-button>
                                </template>
                            </b-table>
                            </div>

                            <!-- 手機卡片 -->
                            <div class="d-md-none">
                                <div v-if="items.length === 0" class="text-center text-muted py-3">
                                    目前沒有營隊報名紀錄
                                </div>
                                <div v-for="item in items" :key="item.OrderDetailId"
                                    class="camp-reg-card"
                                    :class="{ 'card-group-start': item._showGroup, 'card-unpaid': canPayItem(item) }">
                                    <div class="d-flex justify-content-end mb-1">
                                        <b-badge :variant="item.OrderState === '已取消' ? 'secondary' : 'success'">
                                            {{ item.OrderState }}
                                        </b-badge>
                                    </div>
                                    <div class="font-weight-bold mb-1">{{ item.RelationName }}</div>
                                    <div v-if="item.CampSeriesTitle" class="small text-muted">{{ item.CampSeriesTitle }}</div>
                                    <div class="small text-muted mb-1">{{ item.CampProgramTitle }} / {{ item.CampProductTitle }}</div>
                                    <div class="small text-muted mb-2" v-if="item.CampProductStart">
                                        {{ item.CampProductStart | datefmt('YYYY/MM/DD') }} ~ {{ item.CampProductEnd | datefmt('YYYY/MM/DD') }}
                                    </div>
                                    <div class="d-flex align-items-center justify-content-end">
                                        <b-button variant="link" class="p-1"
                                            @click="openDetail(item.OrderDetailId)"
                                            v-b-tooltip.hover title="查看">
                                            <b-icon icon="eye-fill"></b-icon>
                                        </b-button>
                                        <b-button v-if="canPayItem(item)" variant="link" class="p-1 text-danger"
                                            @click="openCancelModal(item)"
                                            v-b-tooltip.hover title="取消報名">
                                            <b-icon icon="x-circle"></b-icon>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template v-if="rows > 0">
                            <div class="overflow-auto mt-3">
                                <b-pagination align="center" v-model="Param.Paging.pageNumber" :total-rows="rows"
                                    :per-page="Param.Paging.pageSize"></b-pagination>
                            </div>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>

        <!-- 報名資料詳情/編輯 Modal -->
        <b-modal id="modal-registrant-detail" title="報名明細" size="xl"
            hide-footer
            @hidden="resetDetail">
            <div v-if="detailLoading" class="text-center py-4">
                <b-spinner></b-spinner>
            </div>
            <template v-else-if="detail.OrderNo">
                <b-card class="mb-3 my-camp-reg-detail">
                    <!-- 標頭 -->
                    <div class="d-flex flex-wrap align-items-baseline">
                        <span class="h5 mb-0 mr-2 font-weight-bold">訂單編號 {{ detail.OrderNo }}</span>
                        <b-badge :variant="orderStateVariant(detail.OrderState)">{{ detail.OrderState }}</b-badge>
                    </div>
                    <div v-if="detail.CampSeriesTitle" class="mt-2 small text-muted">{{ detail.CampSeriesTitle }}</div>
                    <div class="mt-1">
                        <b-badge v-if="detail.IsCampAddon" variant="info" class="mr-1">加購</b-badge>
                        {{ detail.CampProgramTitle }} / {{ detail.CampProductTitle }}
                        <span v-if="detail.CampProductStart" class="text-muted ml-1">
                            （{{ detail.CampProductStart | datefmt('YYYY/MM/DD') }} ~ {{ detail.CampProductEnd | datefmt('YYYY/MM/DD') }}）
                        </span>
                    </div>
                    <div v-if="detail.IsCampAddon && detail.SourceCampProgramTitle" class="mt-1 small text-muted">
                        來源：{{ detail.SourceCampProgramTitle }}<span v-if="detail.SourceCampProductTitle"> / {{ detail.SourceCampProductTitle }}</span>
                    </div>
                    <div v-if="detail.OrderMemo" class="mt-2 small">
                        <span class="text-muted">訂單備註：</span>{{ detail.OrderMemo }}
                    </div>
                    <div v-if="detail.GroupApplyName" class="mt-1 small">
                        <span class="text-muted">團報同行人：</span>{{ formatGroupApplyNames(detail.GroupApplyName) }}
                    </div>

                    <hr class="camp-order-hr" />

                    <!-- 付款資訊 -->
                    <div class="camp-form-section-title">付款資訊</div>
                    <b-row>
                        <b-col cols="12" md="4">
                            <small class="text-muted">原始金額</small>
                            <div>{{ detail.OriginalPrice | money(0, 2) }} 元</div>
                        </b-col>
                        <b-col cols="12" md="4">
                            <small class="text-muted">應付金額</small>
                            <div>{{ detail.Price | money(0, 2) }} 元</div>
                        </b-col>
                        <b-col cols="12" md="4">
                            <small class="text-muted">付款狀態</small>
                            <div>
                                <b-badge v-if="detail.PaymentState" :variant="paymentStateVariant(detail.PaymentState)">{{ detail.PaymentState }}</b-badge>
                                <span v-else>-</span>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="discountDescription(detail)" class="mt-2">
                        <b-col cols="12">
                            <small class="text-muted">優惠描述</small>
                            <div><span class="camp-discount-tag">{{ discountDescription(detail) }}</span></div>
                        </b-col>
                    </b-row>

                    <hr class="camp-order-hr" />

                    <!-- 學員基本資料 -->
                    <div class="camp-form-section-title">學員基本資料</div>
                    <p v-if="isEditing" class="small text-muted mb-2">標示 <span class="text-danger">*</span> 為必填項目</p>
                    <b-row>
                        <b-col cols="12" md="4">
                            <b-form-group>
                                <template #label>學員姓名 <span class="text-danger">*</span></template>
                                <b-form-input v-model="detail.Name" :disabled="!isEditing" :state="submitAttempted && !detail.Name ? false : null" />
                                <b-form-invalid-feedback>請填寫學員姓名</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="8">
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group label="英文姓氏">
                                        <b-form-input v-model="detail.EnglishLastName" placeholder="選填" maxlength="255" :disabled="!isEditing" />
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group label="英文名字">
                                        <b-form-input v-model="detail.EnglishFirstName" placeholder="選填" maxlength="255" :disabled="!isEditing" />
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group label="英文別名">
                                        <b-form-input v-model="detail.EnglishName" placeholder="選填，例如 Steven" maxlength="255" :disabled="!isEditing" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-form-text v-if="isEditing" class="mb-3">姓與名請分開填寫，與護照相同</b-form-text>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group label="身分證字號">
                                <b-form-input v-model="detail.PersonalId" :disabled="!isEditing" />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group>
                                <template #label>性別 <span class="text-danger">*</span></template>
                                <b-form-radio-group v-model="detail.Gender" :disabled="!isEditing" :state="submitAttempted && !detail.Gender ? false : null">
                                    <b-form-radio :value="1">男</b-form-radio>
                                    <b-form-radio :value="2">女</b-form-radio>
                                </b-form-radio-group>
                                <b-form-invalid-feedback :state="submitAttempted && !detail.Gender ? false : null">請選擇性別</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="4">
                            <b-form-group>
                                <template #label>生日 <span class="text-danger">*</span></template>
                                <b-form-input v-model="detail.BirthdayDate" type="date" :disabled="!isEditing" :state="submitAttempted && !detail.BirthdayDate ? false : null" />
                                <b-form-invalid-feedback>請填寫生日</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group>
                                <template #label>年級 <span class="text-danger">*</span></template>
                                <b-form-select v-model="detail.Grade" :options="gradeOptions" :disabled="!isEditing" :state="submitAttempted && (detail.Grade === null || detail.Grade === undefined || detail.Grade === '') ? false : null" />
                                <b-form-invalid-feedback :state="submitAttempted && (detail.Grade === null || detail.Grade === undefined || detail.Grade === '') ? false : null">請選擇年級</b-form-invalid-feedback>
                                <b-form-text v-if="isEditing && !gradeSummerNotice" class="text-muted">請依新學年度為主</b-form-text>
                                <b-form-text v-if="isEditing && gradeSummerNotice" class="text-danger">{{ gradeSummerNotice }}</b-form-text>
                                <b-form-text v-if="isEditing && gradeBirthdayMismatch" class="text-warning">
                                    {{ gradeBirthdayMismatchMessage }}
                                </b-form-text>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group>
                                <template #label>學校 <span class="text-danger">*</span></template>
                                <b-form-input v-model="detail.School" :disabled="!isEditing" :state="submitAttempted && !detail.School ? false : null" />
                                <b-form-invalid-feedback>請填寫就讀學校</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4" v-if="showGradeMemo">
                            <b-form-group>
                                <template #label>年級備註 <span class="text-danger">*</span></template>
                                <b-form-input v-model="detail.GradeMemo" placeholder="請說明目前就學狀況" :disabled="!isEditing"
                                    :state="submitAttempted && !detail.GradeMemo ? false : null" />
                                <b-form-invalid-feedback>年級為其他時，年級備註為必填</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <hr class="camp-order-hr" />

                    <!-- 緊急聯絡 -->
                    <div class="camp-form-section-title">緊急聯絡</div>
                    <b-row>
                        <b-col cols="12" md="4">
                            <b-form-group label="緊急聯絡人">
                                <b-form-input v-model="detail.EmergencyContact" :disabled="!isEditing" />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group label="聯絡人關係">
                                <b-form-input v-model="detail.EmergencyRelation" :disabled="!isEditing" />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group label="緊急聯絡電話">
                                <b-form-input v-model="detail.EmergencyPhone" :disabled="!isEditing" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <hr class="camp-order-hr" />

                    <!-- 特殊需求 -->
                    <div class="camp-form-section-title">特殊需求</div>
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-group label="飲食">
                                <b-form-radio-group v-model="detail.IsVegetarian" :disabled="!isEditing">
                                    <b-form-radio :value="false">葷</b-form-radio>
                                    <b-form-radio :value="true">素</b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group label="過敏史">
                                <b-form-input v-model="detail.Allergy" :disabled="!isEditing" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-group label="飲食備註">
                                <b-form-textarea v-model="detail.DietMemo" rows="2" :disabled="!isEditing" />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group label="醫療備註">
                                <b-form-textarea v-model="detail.MedicalMemo" rows="2" :disabled="!isEditing" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="isEditing || detail.Memo">
                        <b-col cols="12">
                            <b-form-group label="備註">
                                <b-form-textarea v-model="detail.Memo" rows="2" :disabled="!isEditing" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
                <b-form-checkbox v-if="isEditing" v-model="syncToLearnerProfile" class="mt-1">
                    同步更新到家庭成員資料
                </b-form-checkbox>
                <div v-if="!detail.CanEdit && !isEditing" class="text-muted mt-2">
                    <small>目前付款狀態不允許修改報名資料。</small>
                </div>
                <div class="d-flex justify-content-end mt-3">
                    <template v-if="!isEditing">
                        <b-button v-if="detail.CanEdit" variant="primary" @click="isEditing = true">編輯</b-button>
                        <b-button variant="secondary" class="ml-2" @click="$bvModal.hide('modal-registrant-detail')">關閉</b-button>
                    </template>
                    <template v-else>
                        <b-button variant="outline-secondary" @click="cancelEdit">取消</b-button>
                        <b-button variant="primary" class="ml-2" :disabled="detailSaving" @click="handleSaveRegistrant">
                            {{ detailSaving ? '儲存中...' : '儲存' }}
                        </b-button>
                    </template>
                </div>
            </template>
        </b-modal>

        <!-- 取消報名 Modal -->
        <b-modal id="modal-cancel-registration" title="取消報名" size="md"
            ok-title="確認取消"
            ok-variant="danger"
            :ok-disabled="cancelSubmitting"
            cancel-title="返回"
            @ok.prevent="submitCancel"
            @hidden="resetCancelForm">
            <p>確定要取消這筆未付款的報名明細嗎？</p>
            <b-form-group label="取消原因（選填）" label-cols-sm="4">
                <b-form-textarea v-model="cancelForm.Memo" rows="2" placeholder="可留空"></b-form-textarea>
            </b-form-group>
        </b-modal>
    </div>
</template>
<script>
import nacUser from '@/components/nacUser.vue';
import { apiCampOrderDetailList, apiCampRegistrantDetail, apiCampRegistrantUpdate, apiCampRegistrationCancel } from '@/api/API.js';
import {
    GradeOptions,
    GRADE_BIRTHDAY_MISMATCH_MESSAGE,
    getGradeSummerNotice,
    validateFamilyMemberFields,
    validateEnglishNameParts,
    isGradeBirthdayMismatch,
    isOtherGrade,
} from '@/utils/campEnums.js';

export default {
    name: 'MyCampRegistration',
    components: { nacUser },
    data() {
        return {
            title: '營隊報名列表',
            Param: {
                Paging: { pageNumber: 1, pageSize: 10 },
                Search: { keywords: '' },
            },
            Search: { keywords: '' },
            items: [],
            rows: 0,
            fields: [
                { key: 'RelationName', label: '學員', thStyle: { width: '16%' } },
                { key: 'CampProgramTitle', label: '營隊名稱', thStyle: { width: '26%' } },
                { key: 'CampProductTitle', label: '梯次', thStyle: { width: '26%' } },
                { key: 'OrderState', label: '狀態', thStyle: { width: '16%' } },
                { key: 'tool', label: '操作', thStyle: { width: '16%' } },
            ],
            gradeOptions: GradeOptions,
            detail: {},
            detailSnapshot: {},
            detailLoading: false,
            detailSaving: false,
            isEditing: false,
            syncToLearnerProfile: false,
            submitAttempted: false,
            cancelTarget: null,
            cancelForm: { Memo: '' },
            cancelSubmitting: false,
        };
    },
    computed: {
        gradeSummerNotice() {
            return getGradeSummerNotice();
        },
        gradeBirthdayMismatchMessage() {
            return GRADE_BIRTHDAY_MISMATCH_MESSAGE;
        },
        gradeBirthdayMismatch() {
            return isGradeBirthdayMismatch(this.detail.Grade, this.detail.BirthdayDate);
        },
        showGradeMemo() {
            return isOtherGrade(this.detail.Grade);
        },
    },
    watch: {
        'Param.Paging.pageNumber'(newVal) {
            this.GetList(newVal);
        },
        'Search.keywords'(newVal) {
            this.Param.Search.keywords = encodeURI(newVal);
            this.GetList(1);
        },
    },
    mounted() {
        if (this.IsNull(this._sessionData('TokenID')) == '') {
            alert('尚未登入');
            this._go('/');
            return;
        }
        this.GetList();
    },
    methods: {
        discountDescription(item) {
            return item?.DiscountDescription || '';
        },
        logout() {
            const data1 = this._storeData('Header_form1');
            if (this.IsNull(data1) !== '') {
                data1.text = '學員登入';
            }
            this._sessionData('NewToken', '');
            this._sessionData('TokenID', '');
            this._sessionData('campCartCachedCount', '');
            this._sessionData('courseCartCachedCount', '');
            this._go('/');
        },
        GetList(val) {
            this.items = [];
            this.loadSet.show = true;
            this.Param.Paging.pageNumber = val || 1;
            apiCampOrderDetailList(this.Param)
                .then((res) => {
                    const paging = JSON.parse(res.headers['list-header']).Paging;
                    this.rows = paging.totalCount;
                    this.items = this._markGroups(res.data);
                    this.loadSet.show = false;
                })
                .catch((err) => {
                    this.loadSet.show = false;
                    console.log(err);
                });
        },
        _markGroups(data) {
            let lastOrderNo = null;
            return data.map((item) => {
                const _showGroup = item.OrderNo !== lastOrderNo;
                lastOrderNo = item.OrderNo;
                return { ...item, _showGroup };
            });
        },
        rowClass(item) {
            if (!item) return '';
            return [
                item._showGroup ? 'group-start' : '',
                this.canPayItem(item) ? 'payment-unpaid' : '',
            ].filter(Boolean).join(' ');
        },
        canPayItem(item) {
            return item && item.PaymentState === '待付款' && item.OrderState !== '已取消';
        },
        paymentStateVariant(status) {
            if (status === '待付款') return 'warning';
            if (status === '對帳中') return 'info';
            if (status === '已付款') return 'success';
            if (status === '對帳失敗') return 'danger';
            if (status === '已取消') return 'secondary';
            return 'secondary';
        },
        orderStateVariant(status) {
            if (status === '已取消') return 'secondary';
            if (status === '已報名') return 'success';
            return 'light';
        },
        formatGroupApplyNames(value) {
            const text = String(value || '').trim();
            if (!text) return '';
            if (!text.startsWith('[')) return text;
            try {
                const names = JSON.parse(text);
                return Array.isArray(names) ? names.filter(Boolean).join('、') : text;
            } catch {
                return text;
            }
        },
        openDetail(orderDetailId) {
            this.detail = {};
            this.detailLoading = true;
            this.syncToLearnerProfile = false;
            this.submitAttempted = false;
            this.$bvModal.show('modal-registrant-detail');
            apiCampRegistrantDetail(orderDetailId)
                .then((res) => {
                    const d = res.data;
                    const mapped = {
                        ...d,
                        _orderDetailId: orderDetailId,
                        BirthdayDate: d.Birthday ? d.Birthday.substring(0, 10) : '',
                    };
                    this.detail = mapped;
                    this.detailSnapshot = { ...mapped };
                    this.detailLoading = false;
                })
                .catch(() => {
                    this.detailLoading = false;
                });
        },
        resetDetail() {
            this.detail = {};
            this.detailSnapshot = {};
            this.isEditing = false;
            this.syncToLearnerProfile = false;
            this.submitAttempted = false;
        },
        cancelEdit() {
            this.detail = { ...this.detailSnapshot };
            this.isEditing = false;
            this.syncToLearnerProfile = false;
            this.submitAttempted = false;
        },
        handleSaveRegistrant() {
            this.submitAttempted = true;
            this.detail.EnglishLastName = (this.detail.EnglishLastName || '').trim();
            this.detail.EnglishFirstName = (this.detail.EnglishFirstName || '').trim();
            this.detail.EnglishName = (this.detail.EnglishName || '').trim();

            const fieldError = validateFamilyMemberFields(
                this.detail.Name,
                this.detail.BirthdayDate,
                this.detail.Gender,
                this.detail.School,
                this.detail.Grade,
                this.detail.GradeMemo,
            );
            const englishNameError = validateEnglishNameParts(this.detail.EnglishLastName, this.detail.EnglishFirstName, this.detail.EnglishName);
            if (fieldError || englishNameError) {
                alert(fieldError || englishNameError);
                return;
            }

            this.detailSaving = true;
            const payload = {
                Name: this.detail.Name,
                PersonalId: this.detail.PersonalId,
                Gender: this.detail.Gender,
                Birthday: this.detail.BirthdayDate || null,
                Grade: this.detail.Grade != null ? this.detail.Grade : null,
                School: this.detail.School,
                EmergencyContact: this.detail.EmergencyContact,
                EmergencyRelation: this.detail.EmergencyRelation,
                EmergencyPhone: this.detail.EmergencyPhone,
                Allergy: this.detail.Allergy,
                IsVegetarian: this.detail.IsVegetarian,
                DietMemo: this.detail.DietMemo,
                MedicalMemo: this.detail.MedicalMemo,
                Memo: this.detail.Memo,
                EnglishLastName: this.detail.EnglishLastName,
                EnglishFirstName: this.detail.EnglishFirstName,
                EnglishName: this.detail.EnglishName,
                GradeMemo: this.detail.GradeMemo,
                SyncToLearnerProfile: this.syncToLearnerProfile,
            };
            apiCampRegistrantUpdate(this.detail._orderDetailId, payload)
                .then(() => {
                    this.detailSaving = false;
                    this.$bvModal.hide('modal-registrant-detail');
                    alert('報名資料已儲存');
                    this.GetList(this.Param.Paging.pageNumber);
                })
                .catch(() => {
                    this.detailSaving = false;
                });
        },
        openCancelModal(item) {
            this.cancelTarget = item;
            this.$bvModal.show('modal-cancel-registration');
        },
        resetCancelForm() {
            this.cancelTarget = null;
            this.cancelForm = { Memo: '' };
        },
        submitCancel() {
            if (!this.cancelTarget) return;
            this.cancelSubmitting = true;
            apiCampRegistrationCancel(this.cancelTarget.OrderDetailId, { Memo: this.cancelForm.Memo || null })
                .then(() => {
                    this.cancelSubmitting = false;
                    this.$bvModal.hide('modal-cancel-registration');
                    this.GetList(this.Param.Paging.pageNumber);
                })
                .catch(() => {
                    this.cancelSubmitting = false;
                });
        },
    },
};
</script>
<style>
.my-camp-reg .camp-form-section-title {
    color: #6c757d;
    font-size: 0.875rem;
    font-weight: 700;
    margin-bottom: 0.75rem;
}

.my-camp-reg .camp-order-hr {
    margin: 1rem 0;
}

.my-camp-reg .camp-reg-table td {
    vertical-align: middle;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}

.my-camp-reg .group-start td {
    border-top: 2px solid #adb5bd !important;
}

.my-camp-reg .payment-unpaid td {
    background-color: #fff8e1;
}

.my-camp-reg .camp-reg-card {
    padding: 12px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    margin-bottom: 8px;
    background: #fff;
}

.my-camp-reg .camp-reg-card.card-group-start {
    border-top: 2px solid #adb5bd;
}

.my-camp-reg .camp-reg-card.card-unpaid {
    background-color: #fff8e1;
}

.my-camp-reg .camp-discount-tag {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    padding: 2px 8px;
    margin-right: 4px;
    border: 1px solid #f1aeb5;
    border-radius: 4px;
    background: #fff5f5;
    color: #b02a37;
    font-size: 0.8125rem;
    font-weight: 700;
    vertical-align: middle;
}
</style>
